module.exports = __webpack_public_path__ + "img/shipo-menu-barge-line-up.721abc0a.svg";